module.exports = __webpack_public_path__ + "img/vision_03_2x.b7da4bcd.webp";